import React from 'react';
import Moment from 'react-moment';
import { withStyles} from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import IconButton from '@material-ui/core/IconButton';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import LocalLibraryOutlinedIcon from '@material-ui/icons/LocalLibraryOutlined';
import BookOutlinedIcon from '@material-ui/icons/BookOutlined';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import ScheduleIcon from '@material-ui/icons/Schedule';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import SwapVertIcon from '@material-ui/icons/SwapVert';
import CheckIcon from '@material-ui/icons/Check';

const styles = theme => ({
  root: {
    display: 'block',
    width: '100%',
    border: '1px solid #f5f5f5',
    borderRadius: 5,
    overflowX: 'auto',
    '-webkit-overflow-scrolling': 'touch',
    '-ms-overflow-style': '-ms-autohiding-scrollbar',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    '& thead tr th': {
      padding: 5,
      textAlign: 'center',
      fontSize: 12,
      border: '1px solid #f5f5f5',
      cursor: 'pointer',
    },
    '& tbody tr td': {
      padding: 10,
      border: '1px solid #f5f5f5',
    },
    '& tbody tr:nth-of-type(odd) td': {
      backgroundColor: '#fafafa',
    },
  },
  tableHeadingText: {
    lineHeight: 2,
    '& b': {
      verticalAlign: 'super',
    },
  },
  feedbackBadge: {
    display: 'inline-block',
    borderRadius: 15,
    backgroundColor: '#ffc107',
    color: '#212121',
    padding: '5px 15px',
  },
  textCenter: {
    textAlign: 'center',
  },
  textMute: {
    color: '#999999',
  },
});

class HomeworkGroupTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sort: null,
      sortDirection: null,
    };

    this.columns = [
      {
        key: 'detail',
        headingWidth: 45,
        content: (entry) => {
          return (
            <React.Fragment>
              <IconButton
                onClick={this.props.onEntryClick.bind(this, entry)}
                className="open-homework-details-button"
              >
                <OpenInNewIcon />
              </IconButton>
            </React.Fragment>
          );
        },
      },
      {
        key: 'title',
        headingWidth: 78,
        headingIcon: <LocalLibraryOutlinedIcon fontSize="small" />,
        headingText: props.t('Homework'),
        content: (entry) => {
          return (
            <React.Fragment>
              {entry.title}
            </React.Fragment>
          );
        },
      },
      {
        key: 'teacher',
        headingWidth: 90,
        headingIcon: <AccountCircleOutlinedIcon fontSize="small" />,
        headingText: props.t('Teacher'),
        content: (entry) => {
          return (
            <React.Fragment>
              {entry.teacher}
            </React.Fragment>
          );
        },
      },
      {
        key: 'lesson',
        headingWidth: 90,
        headingIcon: <BookOutlinedIcon fontSize="small" />,
        headingText: props.t('Lesson'),
        content: (entry) => {
          return (
            <React.Fragment>
              {entry.lesson}
            </React.Fragment>
          );
        },
      },
      {
        key: 'subject',
        headingWidth: 78,
        headingIcon: <BookOutlinedIcon fontSize="small" />,
        headingText: props.t('Subject'),
        content: (entry) => {
          return (
            <React.Fragment>
              {entry.subject}
            </React.Fragment>
          );
        },
      },
      {
        key: 'issue_date',
        headingWidth: 78,
        headingIcon: <CalendarTodayIcon fontSize="small" />,
        headingText: props.t('Issued'),
        content: (entry) => {
          return (
            <React.Fragment>
              <Moment format="dddd">{entry.issue_date}</Moment>
              <br />
              <Moment format={dateFormat}>{entry.issue_date}</Moment>
            </React.Fragment>
          );
        },
      },
      {
        key: 'due_date',
        headingWidth: 58,
        headingIcon: <CalendarTodayIcon fontSize="small" />,
        headingText: props.t('Due'),
        content: (entry) => {
          return (
            <React.Fragment>
              <Moment format="dddd">{entry.due_date}</Moment>
              <br />
              <Moment format={dateFormat}>{entry.due_date}</Moment>
            </React.Fragment>
          );
        },
      },
      {
        key: 'completion_time_value',
        headingWidth: 78,
        headingIcon: <ScheduleIcon fontSize="small" />,
        headingText: props.t('Est. time'),
        content: (entry) => {
          return (
            <React.Fragment>
              {entry.completion_time_value && (
                <span>{entry.completion_time_value} {entry.completion_time_unit}</span>
              )}
            </React.Fragment>
          );
        },
      },
      {
        key: 'homework_type',
        headingWidth: 68,
        headingIcon: <LocalOfferIcon fontSize="small" />,
        headingText: props.t('Type'),
        content: (entry) => {
          return (
            <React.Fragment>
              {entry.homework_type}
            </React.Fragment>
          );
        },
      },
    ];

    if (props.homeworksMeta.display_marks) {
      this.columns.push({
        key: 'mark',
        headingWidth: 60,
        headingIcon: <CheckIcon fontSize="small" />,
        headingText: props.t('Mark'),
        content: (entry) => {
          return (
            <React.Fragment>
              {entry.status?.mark}
            </React.Fragment>
          );
        },
      });
    }

    if (props.homeworksMeta.allow_attachments) {
      this.columns.push({
        key: 'feedback',
        headingWidth: 100,
        headingIcon: <AttachFileIcon fontSize="small" />,
        headingText: props.t('Feedback'),
        content: (entry) => {
          return (
            <React.Fragment>
              {entry.status.has_feedback && (
                <div className={props.classes.feedbackBadge}>
                  {props.t('Feedback')}
                </div>
              )}
            </React.Fragment>
          );
        },
      });
    }

    this.onTableHeadingClick = this.onTableHeadingClick.bind(this);
    this.getFinalEntries = this.getFinalEntries.bind(this);
  }

  onTableHeadingClick(column) {
    const {
      sort,
      sortDirection,
    } = this.state;

    if (column.key === 'details') {
      return;
    }

    let newSort = column.key;
    let newSortDirection = sortDirection;

    if (!newSortDirection) {
      newSortDirection = 'asc';
    }

    if (newSort === sort) {
      newSortDirection = newSortDirection === 'asc'
        ? 'desc'
        : 'asc';
    }

    this.setState({
      sort: newSort,
      sortDirection: newSortDirection,
    });
  }

  getFinalEntries(entries) {
    const {
      sort,
      sortDirection,
    } = this.state;

    let finalEntries = [ ...entries ];

    finalEntries.sort((a, b) => {
      if (sort === 'feedback') {
        return a.status.has_feedback === b.status.has_feedback
          ? 0
          : (a.status.has_feedback
              ? -1
              : 1
          );
      }

      if (
        sort === 'due_date' ||
        sort === 'issue_date'
      ) {
        return a[sort] === b[sort]
          ? 0
          : (a[sort] > b[sort]
            ? 1
            : -1
          );
      }

      if (
        typeof a[sort] !== 'undefined' &&
        typeof b[sort] !== 'undefined' &&
        a[sort] !== null
      ) {
        if (sort === 'completion_time_value') {
          let a_value = a.completion_time_value * 1;
          if (a.completion_time_unit === 'hours') {
            a_value = a_value * 60;
          } else if (a.completion_time_unit === 'days') {
            a_value = a_value * 60 * 8;
          } else if (a.completion_time_unit === 'weeks') {
            a_value = a_value * 60 * 8 * 5;
          }

          let b_value = b.completion_time_value * 1;
          if (b.completion_time_unit === 'hours') {
            b_value = b_value * 60;
          } else if (b.completion_time_unit === 'days') {
            b_value = b_value * 60 * 8;
          } else if (b.completion_time_unit === 'weeks') {
            b_value = b_value * 60 * 8 * 5;
          }

          return a_value === b_value
            ? 0
            : (a_value > b_value ? 1 : -1);
        }

        return a[sort].localeCompare(b[sort]);
      }

      if (sort === 'mark') {
        return a.status.mark_relative - b.status.mark_relative;
      }

      return 0;
    });

    if (sortDirection === 'desc') {
      finalEntries = finalEntries.reverse();
    }

    return finalEntries;
  }

  render() {
    const {
      classes,
      entries,
    } = this.props;
    const {
      sort,
      sortDirection,
    } = this.state;

    const finalEntries = this.getFinalEntries(entries);

    return (
      <div className={`homework-group-table ${classes.root}`}>
        <table className={classes.table}>
          <thead>
            <tr>
              {this.columns.map((column) => {
                let columnProps = {
                  style: {},
                };
                if (column.headingWidth) {
                  columnProps.style.minWidth = column.headingWidth + 'px';
                }

                return (
                  <th
                    { ...columnProps }
                    key={column.key}
                    onClick={this.onTableHeadingClick.bind(this, column)}
                  >
                    <div>{column.headingIcon}</div>
                    <div className={classes.tableHeadingText} { ...columnProps }>
                      <b>{column.headingText}</b>
                      {(column.key !== sort || !sortDirection) && column.key !== 'detail' && (
                        <span>
                          <SwapVertIcon className={classes.textMute} fontSize="small" />
                        </span>
                      )}
                      {column.key === sort && sortDirection && column.key !== 'detail' && (
                        <span>
                          {sortDirection === 'asc' && (
                            <ArrowUpwardIcon fontSize="small" />
                          )}
                          {sortDirection === 'desc' && (
                            <ArrowDownwardIcon fontSize="small" />
                          )}
                        </span>
                      )}
                    </div>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {finalEntries.map((entry) => {
              return (
                <tr key={entry.id}>
                  {this.columns.map((column) => {
                    return (
                      <td key={column.key} className={classes.textCenter}>
                        {column.content.bind(this, entry)()}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default withStyles(styles)(withTranslation()(HomeworkGroupTable));
